import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Header, Link } from '@vimeo/iris/typography';

import styles from './FancyList.module.scss';

function getAnchorName(anchorPrefix, step) {
  return anchorPrefix + '-step-' + step;
}

const StyledList = styled.ul`
  list-style-type: none;
`;

const FancyList = function (props) {
  const { anchorPrefix, children, numberingElement } = props;

  let tableOfContents = [];
  let blocks = [];
  let NumberingElement = numberingElement;

  function getEntryNumber(step) {
    if (anchorPrefix) {
      step = (
        <a href={`#${getAnchorName(anchorPrefix, step)}`} name={getAnchorName(anchorPrefix, step)}>
          {step}
        </a>
      );
    }

    if (NumberingElement) {
      return <NumberingElement>{step}</NumberingElement>;
    }

    return <Header size="3">{step}</Header>;
  }

  children.forEach((child, i) => {
    if (typeof child.props.header !== 'undefined') {
      tableOfContents.push(child.props.header);
    }

    blocks.push(
      <div key={`block-${i}`} className={styles.block_container}>
        <div className={styles.block}>
          <div className={styles.number}>{getEntryNumber(++i)}</div>

          {child}
        </div>
      </div>,
    );
  });

  return (
    <div>
      {tableOfContents.length > 0 && (
        <FancyListTableOfContents anchorPrefix={anchorPrefix} items={tableOfContents} />
      )}

      <div className={styles.blocks}>{blocks}</div>
    </div>
  );
};

const FancyListItem = function (props) {
  return <div className={styles.content}>{props.children}</div>;
};

const FancyListTableOfContents = function (props) {
  const { anchorPrefix, items } = props;

  return (
    <StyledList>
      {Object.keys(items).map(function (entry, i) {
        let step = ++i;

        return (
          <li key={i}>
            <Link variant="minimal" href={`#${getAnchorName(anchorPrefix, step)}`}>
              <strong>Step {step}.</strong> {items[entry]}
            </Link>
          </li>
        );
      })}
    </StyledList>
  );
};

FancyList.propTypes = {
  anchorPrefix: PropTypes.string,
  children: PropTypes.arrayOf(FancyListItem),
  numberingElement: PropTypes.oneOfType([PropTypes.bool, PropTypes.element, PropTypes.func]),
};

FancyListItem.propTypes = {
  header: PropTypes.string,
};

FancyListTableOfContents.propTypes = {
  anchorPrefix: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
};

export { FancyList, FancyListItem, FancyListTableOfContents };
